import React, {useEffect} from "react";
import {useSelector} from 'react-redux';
import {useAuth0} from "@auth0/auth0-react";
import {history} from "_helpers";
import ReactGA from 'react-ga';
import {GOOGLE_ANALYTICS_TRACKING_ID} from "_constants";

function Auth0Init () {

  useEffect(() => {
    ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
    ReactGA.pageview(window.location.pathname);

    }, []);

  const {isLoading, loginWithRedirect, isAuthenticated} = useAuth0();
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const auth0 = useSelector((state) => state.auth0);
  const {logoutLoading} = auth0;
  const slug = 'login';

  /**
   * If a user is currently logged in, redirect
   */
  if (currentUser) {
    history.push('/dashboard');
  }

  if(!currentUser && !logoutLoading && !isLoading && isAuthenticated){
    history.push('/contact-support')
  }

  if(!currentUser && !isLoading && !isAuthenticated) {
    const params = new URLSearchParams(window.location.search);
    let returnTo = params.get("returnTo");

    if (returnTo) {
      try {
        returnTo = decodeURIComponent(returnTo);
      } catch (e) {
        console.warn("Failed to decode returnTo param:", e);
      }
    }

    loginWithRedirect({
      screen_hint: `${slug}`,
      appState: { returnTo }
    });
  }

  return <div/>;
}

export default Auth0Init;
